export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.7f5af375.worker.js");
}
